<template>
	<div class="container-fluid rtl">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h3 class="panel-title rtl">סרטים לפרויקט "{{category.name}}"</h3>
			</div>
			<div class="container-fluid">
        <div class="col-md-12">
          <input type="text" class="form-control" name="search" placeholder="חפש" v-model="search" @keyup="callList()">
        </div>
				<div class="col-md-12 table-responsive addSomePadding">
					<table class="table" v-loading="loading">
						<thead>
							<tr>
								<th>שם</th>
								<th>מילים</th>
								<th>הורד</th>
								<th>כלים</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in list" :key="item.id">
								<td>{{item.name}}</td>
								<td>{{Math.ceil(item.total_words / 250)}}</td>
								<td class="nowarp">
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'txtspk')">Avid Speakers</button>
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'txt')">Avid Locators</button>
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'txtsrt')">Avid Subcap</button>
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'srt')">SRT</button>
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'docx')">Word</button>
								  <button class="downloadButton" v-on:click.prevent="downloadJson(item.id, item.name, 'odt')">OpenOffice</button>
                </td>
								<td class="nowarp">
                  <a href="javascript:void(0)" v-on:click.prevent="edit(item)">
										<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
									</a>
                  &nbsp;
                  <a class="text-danger" href="javascript:void(0)" v-on:click.prevent="remove(item.id)">
										<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
									</a>
								</td>
							</tr>
						</tbody>
					</table>
          <div class="text-center col-md-12" dir="ltr">
            <el-pagination layout="prev, pager, next" @current-change="callList" :total="total"></el-pagination>
          </div>
          <div class="text-center col-md-12">
            <button type="button" class="btn btn-primary" v-on:click.prevent="$router.push({ name: 'home'})">חזור לפרוייקטים</button>
            <button type="button" class="btn btn-primary" v-on:click.prevent="add({id:0,name:'',interviewer:''})">הוסף סרט</button>
          </div>
				</div>
			</div>
		</div>
		<div class="popupForm" v-if="obj != null">
			<div class="panel-heading">
				<h3 class="panel-title" v-text="addEditTitle">Save Video</h3>
			</div>
			<div class="container-fluid addSomePadding">
        <div-vali class="col-md-12 rtl" :errorVee="errors.has('file')" labelTxt="קובץ JSON">
					<input type="file" name="file" class="form-control" ref="file" v-on:change="handleFileUpload()" v-validate="getFileRequired()">
        </div-vali>
				<div-vali class="col-md-12" :errorVee="errors.has('name')" labelTxt="שם סרט">
					<input type="text" name="name" class="form-control" v-model="obj.name" v-validate data-vv-rules="required">
        </div-vali>
				<div-vali class="col-md-12" :errorVee="errors.has('interviewer')" labelTxt="מרואיין">
					<input type="text" name="interviewer" class="form-control" v-model="obj.interviewer" v-validate data-vv-rules="required">
        </div-vali>
				<div class="text-center col-md-12">
					<button type="button" class="btn btn-warning" v-on:click.prevent="cancel()">בטל</button>
					<button type="button" class="btn btn-primary" v-on:click.prevent="save()">שמור</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import Util from "@/util/Utils2.js";
import DivValidation from "@/components/shared/utils/DivValidation.vue";
import BasicoService from "@/service/BasicoService.js";
export default {
  components: {
    "div-vali": DivValidation
  },
  data() {
    return {
      api: '',
      search: '',
      loading: true,
      total: 0,
      id: null,
      category: {},
      obj: null,
      file: null,
      list: [],
      addEditTitle:'הוספת סרטון חדש'
    };
  },
  methods: {
    getFileRequired() {
      return this.obj && this.obj.id == 0 ? 'required' : ''
    },
    getFilename(name, type) {
      let filename = name
      if (type == 'docx') {
        filename += '_w.docx'
      }
      else if (type == 'odt') {
        filename += '_o.odt'
      }
      else if (type == 'txtsrt') {
        filename += '.txt'
      }
      else if (type == 'txtspk') {
        filename += '.txt'
      }
      else {
        filename += '.'+type
      }
      return filename
    },
    getMime(type) {
      switch(type) {
        case 'docx':
        case 'odt':
          return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=ANSI'
        case 'txt':
        case 'txtspk':
          return 'text/plain;charset=Windows-1255'
        case 'srt':
          return 'text/plain;charset=UTF-8'
        case 'txtsrt':
          return 'text/plain;charset=UTF-8-BOM'
        default:
          return ''
      }
    },
    downloadJson(id, name, type) {
      let basicoService = new BasicoService(this)
      basicoService.videoExport(id, type).then(response => {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data],{type:this.getMime(type)}))
        link.setAttribute('download', this.getFilename(name, type))
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
      let temp = this.file.name.split('.')
      if (temp.length > 1) {
        temp.pop()
      }
      this.obj.name = temp.join('.')
      if (this.file) {
        let reader = new FileReader()
        reader.readAsText(this.file)
        reader.onload = this.onJsonFinishLoad
      }
    },
    onJsonFinishLoad(evt) {
      let speakers = []
      let fileJson = JSON.parse(evt.target.result)
      fileJson.settings.channels.forEach(function(channel){
        channel.speaker.forEach(function(speaker){
          speakers.push(speaker)
        })
      })
      this.obj.interviewer = speakers.join(', ')
    },
    callCategory() {
      let basicoService = new BasicoService(this)
      basicoService.category(this.id).then(category => {
        if (category) {
          this.category = category.data
        }
      });
    },
    callList(page=1) {
      this.loading = true
      let basicoService = new BasicoService(this);
      basicoService.videoList(this.id, this.search, page).then(list => {
        if (list) {
          this.total = list.data.total
          this.list = list.data.data
        }
        this.loading = false
      });
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let data = new FormData()
          data.append('id', this.obj.id)
          data.append('name', this.obj.name)
          data.append('interviewer', this.obj.interviewer)
          data.append('category_id', this.id)
          if (this.file) {
            data.append('file', this.file)
          }
          let basicoService = new BasicoService(this)
          basicoService.videoSave(this.obj.id, data).then(res => {
            if (res) {
              Util.showMessage("סרטון נשמר", "success")
            } else {
            }
            this.cancel()
          });
        }
      });
    },
    remove(id) {
      if (confirm("בטוח להסיר?")) {
        let basicoService = new BasicoService(this)
        basicoService.videoDelete(id).then(res => {
          if (res) {
            Util.showMessage("סרטון הוסר בהצלחה", "success")
          } else {
          }
          this.cancel()
        });
      }
    },
    add(obj) {
      this.obj = obj
      this.addEditTitle='הוספת סרטון חדש'
    },
    edit(obj) {
      this.obj = obj
      this.addEditTitle='עריכת סרטון קיים'
    },
    cancel() {
      this.file = null
      this.obj = null
      this.callList()
    }
  },
  created() {
    this.api = process.env.API
    this.id = this.$route.params.id
    this.search = ''
    this.callCategory()
    this.callList()
  }
};
</script>
<style>
.popupForm{
  position: fixed;
  top:50%;
  left:50%;
  width:700px;
  height:350px;
  margin-left:-350px;
  margin-top:-175px;
  background-color: rgba(255,255,255,0.95);
  border:#2c2c2c 1px solid;
  border-radius: 5px;
  -webkit-box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
-moz-box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
box-shadow: 1px 11px 41px -6px rgba(0,0,0,0.75);
}
.table thead tr th {
  background-color: #2980b9;
  color: #fff;
  font-size: 28px;
  border-left: 1px #3498db solid;
  width: 100%;
  text-align: right;
  padding-right:20px;
}
.table thead tr th span {
  font-size: 16px;
}
.table thead tr th:last-child {
  border-left: none;
}
.table tbody tr td {
  font-size: 24px;
  color: #2c2c2c;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
  padding-right: 20px;
  padding-left: 20px;
}
.table tbody tr td:last-child {
  border-left: 1px solid #e8e8e8;
}
.table tbody tr td:last-child {
  white-space: nowrap;
}
.table tbody tr:nth-child(odd) {
  background-color: #dee9f1;
}
.table tbody tr td:not(:last-child) span {
  font-size: 18px;
}
.table tfoot tr td {
  text-align: center;
  font-size: 14px;
}
.table tfoot tr td div.paging {
  text-align: center;
  display: inline;
}
.table tfoot tr td div.resultsSummery {
  float: right;
}
.table tfoot tr td div.numOfRows {
  float: left;
}
.mainContainer {
  margin: auto;
}
.nowarp{
  white-space: nowrap;
}
.nowarp button{
  display: inline;
}

.panel-default{
  border:none;
}
.downloadButton{
background-color:#9fd1f1 !important;
border: 1px solid #2980b9;

}
.downloadLink,.downloadLink:hover{
  text-decoration: none;
  color:#2c2c2c;
}

</style>



// WEBPACK FOOTER //
// Video.vue?66dfad19